module.exports = __webpack_public_path__ + "static/media/210901644630381IMG_20220128_161940.e096829d.jpg";